import { RulesList } from "Requests/ProductsRules";
import * as S from "./styles";

interface ClientProductRulesListProps {
  rule: RulesList;
}

export const ClientProductRulesList = ({
  rule,
}: ClientProductRulesListProps) => {
  return (
    <S.RulesList>
      <strong>{rule.client_name}</strong>

      <ul>
        <li className="text-gray" style={{ marginBottom: 8 }}>
          {rule.substitutions?.length ? (
            <span>
              {rule.substitutions.map((s) => `${s.product_name}`).join(", ")}
            </span>
          ) : null}
        </li>
      </ul>
    </S.RulesList>
  );
};
